import React, { useState, useEffect, useContext } from 'react';
import bg from '../assets/bg.jpg';
import quote from '../assets/quote.png';
import { testimonials } from '../Helpers'; // assuming Helper.js exports `testimonials`
import { AppContext } from '../App';

const TestimonialSlider = () => {
  const appContext = useContext(AppContext);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-rotate every 3s
  useEffect(() => {
    if (testimonials.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  // Ensure we always have at least one testimonial to show
  const testimonial = testimonials.length
    ? testimonials[currentIndex]
    : {
        id: 0,
        name: '—',
        title: '',
        organization: '',
        message: 'No testimonials available.',
      };

  return (
    <div
      className="flex justify-center items-center py-10 px-4"
      style={{
       
      }}
    >
	<h5 className='main-section-title text-center'>TESTIMONIALS</h5>
		
      <div
        className="rounded shadow-lg p-8 text-center relative p-3 m-auto"
        style={{ width: '320px',  backgroundImage: `url(${bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center', }} // ~320px (32px is unrealistic for text)
      >
        {/* Quote icon at top */}
        <div className="flex justify-center mb-4">
          <img
            src={quote}
			width={50}
            alt="Quote"
            className="h-8 w-8 opacity-70"
          />
        </div>

        {/* Message */}
        <p className="font-semi-bold">
          {testimonial.message}
        </p>

        {/* Author info */}
        <div>
          <h6 className="font-semi-bold text-gray-900 text-uppercase">{testimonial.name}</h6>
          <h6 className="text-sm text-gray-600">{testimonial.title}</h6>
          <h6 className="text-sm text-gray-500 mt-1">{testimonial.organization}</h6>
        </div>
      </div>
	  <div className='text-center my-5'>
              <button 
                className='btn btn-lg btn-secondary'
                onClick={() => appContext.navTo({item:"testimonials"})}
              >
                View More Testimonials
              </button>
          </div>
    </div>
  );
};

export default TestimonialSlider;